import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row"} }

import Co2QuestionForm from '@/components/co2quiz/Co2QuestionForm.vue';
import Co2CalculatorForm from '@/components/co2quiz/Co2CalculatorForm.vue';
import Co2QuestionsSortingForm from '@/components/co2quiz/Co2QuestionsSortingForm.vue';
import Co2QuizOverview from '@/components/co2quiz/Co2QuizOverview.vue';
import ListFilter from '@/components/common/ListFilter.vue';
import TranslatedState from '@/components/common/TranslatedState.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import {
  Co2QuizQuestion,
  calculationLabelItems,
  getSimpleCalculationType,
} from '@/models/co2-quiz.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import {
  Co2QuizStoreActions,
  Co2QuizStoreState,
} from '@/stores/co2-quiz.store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { CategoriesActions, CategoriesState } from '@/stores/categories.store';
import { Category } from '@/models/category.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2QuizQuestionList',
  setup(__props) {

const store = useStore<
  ShiftCMSState & { co2: Co2QuizStoreState; cs: CategoriesState }
>();
const events = useEvents();

const questions = computed<Co2QuizQuestion[]>(() => store.state.co2.questions);
const categories = computed<Category[]>(() => store.state.cs.categories);

const followQuestions = computed<number[]>(() =>
  questions.value.reduce((acc: number[], i: Co2QuizQuestion) => {
    const followUps: Co2QuizQuestion[] = i.answers
      .filter((a) => a.followUpQuestion)
      .map((a) => a.followUpQuestion)
      .filter((n) => !!n);
    return [...acc, ...followUps.map((f) => f.id)];
  }, []),
);

const relatedQuestions = computed<number[]>(() =>
  questions.value.reduce((acc: number[], i: Co2QuizQuestion) => {
    const related: Co2QuizQuestion[] = i.relatedQuestions;
    return [...acc, ...related.map((f) => f.id)];
  }, []),
);

const chainQuestions = computed<number[]>(() =>
  questions.value.reduce((acc: number[], i: Co2QuizQuestion) => {
    const chained: Co2QuizQuestion | undefined = i.chainQuestion;
    return chained ? [...acc, chained.id] : acc;
  }, []),
);

const update = () => {
  store.dispatch(Co2QuizStoreActions.GetCo2Questions);
  store.dispatch(CategoriesActions.GetCategories);
};

onMounted(() => {
  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, update);
});

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Type', key: 'parentQuestion', width: '10%' },
  { title: 'Title', key: 'title', width: '50%' },
  { title: 'Category', key: 'categories', width: '15%' },
  { title: 'Calculation', key: 'calculationType', width: '20%' },
  { title: 'State', key: 'translated', sortable: false, width: '5%' },
];

const editQuestion = (_: Event, { item }: { item: Co2QuizQuestion }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2QuestionForm),
    data: item,
  });
};

const showCalculator = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2CalculatorForm),
    data: questions,
  });
};

const addQuestion = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2QuestionForm),
  });
};

const sortQuestions = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2QuestionsSortingForm),
    data: questions,
  });
};

const showQuizOverview = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2QuizOverview),
    data: { questions, categories },
  });
};

const filterTitle = ref<string>('');
const filteredQuestions = computed(() =>
  questions.value.filter((v) =>
    filterTitle.value
      ? v.title.toLowerCase().indexOf(filterTitle.value.toLowerCase()) !== -1
      : true,
  ),
);

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filterTitle.value = filters.filterTitle;
}

const options = [
  { label: 'Main', value: 'main' },
  { label: 'Part', value: 'part' },
  { label: 'Sub', value: 'sub' },
  { label: 'Follow-up', value: 'follow-up' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _cache[0] || (_cache[0] = _createTextVNode("CO₂ Quiz Questions ")),
        _createVNode(CurrentLanguage)
      ]),
      _createVNode(ListFilter, {
        onFilter: updateFilter,
        options: options
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: headers,
        items: filteredQuestions.value.sort((a, b) => a.index - b.index),
        "onClick:row": editQuestion,
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.translated": _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TranslatedState, { item: item }, null, 8, ["item"]),
            _cache[1] || (_cache[1] = _createTextVNode("   ")),
            (item.calculationLabels.length)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  icon: "mdi-tag-outline",
                  color: "info",
                  title: item.calculationLabels.map(v => _unref(calculationLabelItems).find(l => l.value === v)).map(v => v!.title).join(', ')
                }, null, 8, ["title"]))
              : _createCommentVNode("", true)
          ])
        ]),
        "item.calculationType": _withCtx(({ item }) => [
          _createVNode(_component_v_chip, {
            color: "info",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getSimpleCalculationType)(item)), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        "item.categories": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.categories[0]?.title), 1)
        ]),
        "item.parentQuestion": _withCtx(({ item }) => [
          _createVNode(_component_v_chip, {
            style: {"font-size":"0.7em"},
            density: "compact",
            color: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.partQuestion
              ? 'Part'
              : item.parentQuestion
              ? 'Sub'
              : followQuestions.value.includes(item.id)
              ? 'Follow-up'
              : chainQuestions.value.includes(item.id)
              ? 'Chained'
              : item.isQuickScan
              ? 'Quick'
              : 'Other') + " " + _toDisplayString(relatedQuestions.value.includes(item.id) ? '/ Related' : ''), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addQuestion,
        color: "success",
        class: "mr-4"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Add Question")
        ])),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        onClick: showCalculator,
        color: "info",
        class: "mr-4"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Calculator")
        ])),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        onClick: sortQuestions,
        color: "info",
        class: "mr-4"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("Sort and Hierarchy")
        ])),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        onClick: showQuizOverview,
        color: "info"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("Quiz overview")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})